@if (isLoadingShowtimes()) {
  <div @showtimeLoadingSwap [@.disabled]="animationsDisabled()">
    <ng-container *ngTemplateOutlet="loading" />
  </div>
} @else if (!onlySubscription()) {
  <div @showtimeLoadingSwap [@.disabled]="animationsDisabled()">
    <div
      class="showtime-streaming-no-options tab-msg"
      [attr.data-translate]="noOptionsMessageKey"
      *ngIf="movie() !== null && !pageTypesOptions"
    >
      {{ noOptionsMessage }}
    </div>
    <div
      id="showtime-streaming"
      class="showtime-streaming"
      *ngIf="movie() !== null && pageTypesOptions.length > 0 && activeType"
    >
      <p-selectButton
        *ngIf="pageTypesOptions.length > 1 || showStreamingTitleAlways"
        [options]="pageTypesOptions"
        optionLabel="label"
        ngSkipHydration
        optionValue="value"
        [(ngModel)]="activeType"
        (onOptionClick)="onSelectButtonOptionClick($event)"
        (onChange)="onSelectButtonChange($event)"
        (ngModelChange)="onChangeType($event)"
        class="tabs"
        [allowEmpty]="false"
        [disabled]="pageTypesOptions.length === 1"
      >
        <ng-template pTemplate="item" let-item>
          <span [attr.data-translate]="'title.' + (item.value | cammelCase)">{{
            item.value | cammelCase | titleLocalize: { defaultValue: item.value }
          }}</span>
        </ng-template>
      </p-selectButton>

      <div class="tab-container">
        @switch (activeType) {
          @case ('in-cinemas') {
            @if (showInCinemas) {
              <ush-showtime-streaming-in-cinemas
                [movie]="movie()"
                [enableRouterNavigation]="enableRouterNavigation"
                [showUsheruLogo]="showUsheruLogo"
                [inCinemasAddon]="inCinemasAddon"
                [openFirstPanel]="openFirstPanel"
                [inlineMap]="inlineMap"
                (showsLoaded)="onShowtimesLoaded()"
                (showtimeTicketing)="onShowtimeTicketingHandle($event)"
              >
              </ush-showtime-streaming-in-cinemas>
            }
          }

          @case ('watch-at-home') {
            @if (showWatchAtHome) {
              <ush-showtime-streaming-watch-at-home
                [movie]="movie()"
                [showUsheruLogo]="showUsheruLogo"
                (streamingPlatformsLoaded)="onStreamingPlatformsLoaded()"
              >
              </ush-showtime-streaming-watch-at-home>
            }
          }

          @case ('at-festivals') {
            @if (showAtFestivals) {
              <ush-showtime-streaming-at-festivals [movieFestivals]="movie().movieFestivals">
              </ush-showtime-streaming-at-festivals>
            }
          }

          @case ('enquiries') {
            <ush-enquiries [movie]="movie()"></ush-enquiries>
          }
        }
      </div>
    </div>
  </div>
}

<!-- Contact us Template -->
<ng-container *ngIf="!forceDisableSubscription">
  <ush-showtime-streaming-subscribe
    *ngIf="showDemandItForm"
    [movie]="movie()"
    [type]="subscribeType"
    [customTitleTr]="customSubscribeTitleTr"
    [customDescTr]="customSubscribeDescTr"
  >
  </ush-showtime-streaming-subscribe>
</ng-container>

<!-- Loading Template-->
<ng-template #loading>
  <div class="showtime-streaming showtime-streaming--skeleton">
    <div class="showtime-streaming--skeleton-tabs">
      @for (item of [1, 2, 3]; track item) {
        <ush-movie-detail-skeleton width="8rem" height="1.5rem" radius="999px"></ush-movie-detail-skeleton>
      }
    </div>
    <ush-movie-detail-skeleton width="100%" height="5rem" radius="18px"></ush-movie-detail-skeleton>
  </div>
</ng-template>
